var _objectAssign = require('./_objectAssign');

module.exports =
  typeof Object.assign === 'function' ? Object.assign : _objectAssign;



//////////////////
// WEBPACK FOOTER
// /home/deploy/7n_staging/shared/~/ramda/src/internal/_assign.js
// module id = 59
// module chunks = 0 2 3 4 5 6 7